import { AppRouter } from './routers/AppRouter';

const App = () => (
    <AppRouter />
);

export default App;
